import { AuthError } from "@supabase/supabase-js";

export const handleErrorLog = (error: AuthError) => {
  if (error) {
    console.error(`Error: ${error.code} - ${error.message}`);
  }
};

export const waitFor = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const formatNumber = (n: number) => {
  if (isNaN(n)) {
    return null;
  }
  return new Number(n).toLocaleString("en-US", { minimumFractionDigits: 2 });
};

export function convertToCSV(data: Array<Record<string, any>>): string {
  if (!data.length) return "";

  const headers = Object.keys(data[0]);
  const rows = data.map((row) =>
    headers.map((field) => JSON.stringify((row as any)[field] ?? "")).join(",")
  );

  return [headers.join(","), ...rows].join("\r\n");
}

export function downloadCSV(csv: string, filename: string) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    filename.endsWith(".csv") ? filename : `${filename}.csv`
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
